import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEprPackagingClass implements BaseEnumType {
  private static allValues: EnumEprPackagingClass[] = []; // make sure this is top-most
  
  public static primary = new EnumEprPackagingClass(0, "Primary", "enum_epr_packaging_class_primary");
  public static secondary = new EnumEprPackagingClass(1, "Secondary", "enum_epr_packaging_class_secondary");
  public static tertiary = new EnumEprPackagingClass(2, "Tertiary", "enum_epr_packaging_class_tertiary");
  public static shipment = new EnumEprPackagingClass(3, "Shipment", "enum_epr_packaging_class_shipment");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEprPackagingClass.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isPrimary() { return this === EnumEprPackagingClass.primary; }
  public isSecondary() { return this === EnumEprPackagingClass.secondary; }
  public isTertiary() { return this === EnumEprPackagingClass.tertiary; }
  public isShipment() { return this === EnumEprPackagingClass.shipment; }

  public static getValues(): readonly EnumEprPackagingClass[] {
    return EnumEprPackagingClass.allValues;
  }

  public static getValuesExcept0(): readonly EnumEprPackagingClass[] {
    return EnumEprPackagingClass.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEprPackagingClass {
    const found = EnumEprPackagingClass.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEprPackagingClass - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEprPackagingClass): EnumEprPackagingClass {
    const found = name ? EnumEprPackagingClass.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEprPackagingClass - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEprPackagingClass>): boolean {
    return this.key === other?.key;
  }
}